import { render, staticRenderFns } from "./addOfficialTempMsg.vue?vue&type=template&id=08bfbeaf&scoped=true&"
import script from "./addOfficialTempMsg.vue?vue&type=script&lang=js&"
export * from "./addOfficialTempMsg.vue?vue&type=script&lang=js&"
import style0 from "./addOfficialTempMsg.vue?vue&type=style&index=0&id=08bfbeaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bfbeaf",
  null
  
)

component.options.__file = "addOfficialTempMsg.vue"
export default component.exports